/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import {Meta} from '@/decorators';
import {MetaInfo} from 'vue-meta';
import ContentBlock from '@/components/ContentBlock/index.vue';

/**
 * Home page view (component).
 *
 * @author Jenny Georgiadou <jgeorgiadou@frontier.co.uk>
 */
@Component({
    name: 'v-faq',
    components: {
        'c-content-block': ContentBlock,
    },
})
export default class Faq extends Vue {
    /**
     * Meta generation.
     *
     *
     * This is an example cascaded meta generator for title and other met properties.
     *
     * @returns {MetaInfo}
     */
    @Meta
    public meta(): MetaInfo {
        const title: string = 'FAQs';

        return {
            title,
            meta: [
                {
                    property: 'og:title',
                    content: `${this.$i18n.translate('application.title', {}) || ''}`,
                },
                {
                    property: 'og:description',
                    content: 'Frequently asked questions.',
                },
                {
                    property: 'og:image',
                    content: window.location.hostname + '/img/og_image.jpg',
                },
            ],
        };
    }
}
